import {h} from 'ui/Framework';

export default h('svg', {
  width: '72',
  height: '16',
  viewBox: '-1 -1 74 18',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('path', {
          stroke: '#9FAAC0',
          d: 'M0 0h72v16H0z'
        }),
        h('path', {
          d: 'M65 9.56h3l-1.5 2-1.5-2zM68 6.56h-3l1.5-2 1.5 2z',
          fill: '#9FAAC0'
        }),
        h('path', {
          d: 'M45.794 11.56h-.72V5.37l-1.28 1.09-.44-.5 1.8-1.48h.64v7.08zm6.58-2.34h1.04v.63h-1.04v1.71h-.7V9.85h-3.24v-.7l3-4.67h.94v4.74zm-.7-3.93h-.02l-2.47 3.93h2.49V5.29zm6.89-.17h-2.95l-.05 2.19c.154-.054.315-.094.485-.12.17-.027.335-.04.495-.04.334 0 .64.053.92.16.28.106.524.258.73.455.207.196.367.431.48.705.114.273.17.573.17.9 0 .34-.056.655-.17.945-.113.29-.273.54-.48.75-.206.21-.455.375-.745.495s-.608.18-.955.18c-.513 0-.946-.117-1.3-.35a2.34 2.34 0 0 1-.82-.94l.65-.29c.127.293.319.526.575.7.257.173.542.26.855.26.24 0 .462-.042.665-.125a1.543 1.543 0 0 0 .87-.885c.084-.207.125-.43.125-.67 0-.26-.045-.495-.135-.705a1.569 1.569 0 0 0-.925-.875 1.979 1.979 0 0 0-.7-.12c-.253 0-.505.035-.755.105-.25.07-.488.165-.715.285l.07-3.65h3.61v.64z',
          fill: '#A3A9B2'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/number-widget.es6.js